// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';


import ScrollToTop from './components/ScrollToTop.js';
import Navbar from './components/Navbar.js';
import Footer from './components/Footer.js';

import Home from './pages/Home.js';
import ProductDetails from './components/ProductDetails.js';
import Cart from './pages/Cart.js';
import Checkout from './pages/Checkout.js';
import OrderSuccess from './pages/OrderSuccess.js';   // ✅ NEW
import MyOrders from './pages/MyOrders.js';
import OrderDetail from './pages/OrderDetail.js';
import Login from './pages/Login.js';
import Register from './pages/Register.js';
import VerifyRegisterOTP from './pages/VerifyRegisterOTP.js';
import Profile from './pages/Profile.js';
import Wishlist from './pages/Wishlist.js';

import NewArrivals from './pages/NewArrivals.js';
import Accessories from './pages/Accessories.js';
import Sale from './pages/Sale.js';

import Productlist from './components/Productlist.js';
import CustomerService from './pages/CustomerService.js';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <Navbar />
          <main className="main-content">
            <Routes>
              {/* Main pages */}
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Productlist />} />
              <Route path="/newarrivals" element={<NewArrivals />} />
              <Route path="/accessories" element={<Accessories />} />
              <Route path="/sale" element={<Sale />} />

              {/* Product & cart flow */}
              <Route path="/product/:slug" element={<ProductDetails />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-success" element={<OrderSuccess />} />   {/* ✅ NEW */}
              <Route path="/orders" element={<MyOrders />} />
              <Route path="/orders/:orderNumber" element={<OrderDetail />} />

              {/* Auth */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-register-otp" element={<VerifyRegisterOTP />} />

              {/* Account */}
              <Route path="/profile" element={<Profile />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/settings" element={<Profile />} />
              <Route path="/account" element={<Profile />} />

              {/* 404 */}

              <Route path="/customer-service" element={<CustomerService />} />
              <Route path="/terms" element={<CustomerService />} />
              <Route path="/privacy" element={<CustomerService />} />
              <Route path="/shipping" element={<CustomerService />} />
              <Route path="/returns" element={<CustomerService />} />
              <Route path="/faq" element={<CustomerService />} />
              <Route
                path="*"
                element={
                  <div style={{ padding: '80px', textAlign: 'center' }}>
                    <h1>404</h1>
                    <p>Page not found</p>
                  </div>
                }
              />
            </Routes>
          </main>
          <Footer />
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;